import faviconSvg from "./icons/icon-a-stage-16.svg?raw";

const CSS = `
@import url("https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap");
.bm-root {
  --bm-ui: "Helvetica Neue", Helvetica, Arial, sans-serif;
  --bm-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  height: 100%; width: 100%; min-height: 0; display: flex; flex-direction: column;
  font-family: var(--bm-ui); -webkit-font-smoothing: antialiased;
}
.bm-list {
  flex: 1; min-height: 0; display: flex; flex-direction: column;
  background: oklch(0.995 0.002 260); color: oklch(0.24 0.01 260);
}
.bm-list-head { padding: 32px 40px 24px; display: flex; align-items: flex-start; justify-content: space-between; gap: 24px; }
.bm-title { display: flex; align-items: center; gap: 12px; }
.bm-mark { width: 34px; height: 34px; border-radius: 9px; flex: none; display: block; }
.bm-list-head h1 { margin: 0; font-size: 28px; font-weight: 600; letter-spacing: -0.02em; }
.bm-list-head p { margin: 6px 0 0 46px; font-size: 14px; color: oklch(0.55 0.01 260); }
.bm-create { height: 44px; padding: 0 22px; border: none; border-radius: 10px; background: oklch(0.55 0.15 255); color: #fff; font: 600 14px var(--bm-ui); cursor: pointer; display: flex; align-items: center; gap: 10px; }
.bm-create:hover { background: oklch(0.48 0.15 255); }
.bm-create[disabled] { background: oklch(0.96 0.003 260); border: 1px solid oklch(0.9 0.005 260); color: oklch(0.68 0.01 260); cursor: not-allowed; }
.bm-create-wrap { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.bm-hostcap { font-family: var(--bm-mono); font-size: 11px; color: oklch(0.6 0.01 260); }
.bm-filters { padding: 0 40px 20px; display: flex; align-items: center; gap: 12px; }
.bm-search { flex: 1; height: 40px; border: 1px solid oklch(0.9 0.005 260); border-radius: 10px; background: oklch(0.98 0.002 260); display: flex; align-items: center; padding: 0 14px; gap: 10px; }
.bm-search input { flex: 1; border: 0; background: transparent; font: 14px var(--bm-ui); outline: none; color: inherit; }
.bm-search input::placeholder { color: oklch(0.66 0.01 260); }
.bm-glyph { width: 11px; height: 11px; border: 1.5px solid oklch(0.68 0.01 260); border-radius: 50%; flex: none; }
.bm-chip { height: 40px; padding: 0 16px; border-radius: 10px; border: 1px solid oklch(0.9 0.005 260); background: transparent; color: oklch(0.42 0.01 260); font: 13px var(--bm-ui); cursor: pointer; display: flex; align-items: center; gap: 8px; }
.bm-chip.on { background: oklch(0.25 0.01 260); color: #fff; border-color: transparent; font-weight: 500; }
.bm-dot { width: 7px; height: 7px; border-radius: 50%; background: oklch(0.68 0.15 150); }
.bm-cards { flex: 1; overflow: auto; padding: 0 40px; display: flex; flex-direction: column; gap: 12px; }
.bm-card { border: 1px solid oklch(0.88 0.005 260); border-radius: 12px; background: #fff; padding: 20px 22px; display: flex; align-items: center; gap: 24px; }
.bm-card:hover { border-color: oklch(0.72 0.08 255); }
.bm-card.idle { background: oklch(0.985 0.002 260); }
.bm-card.idle .bm-name { color: oklch(0.4 0.01 260); }
.bm-card-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 9px; }
.bm-name { font-size: 17px; font-weight: 600; }
.bm-live { display: inline-flex; align-items: center; gap: 6px; padding: 3px 8px; border-radius: 5px; background: oklch(0.95 0.03 150); font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.08em; color: oklch(0.44 0.1 150); }
.bm-live i { width: 6px; height: 6px; border-radius: 50%; background: oklch(0.62 0.16 150); display: block; }
.bm-idrow { display: flex; align-items: center; gap: 10px; }
.bm-id { font-family: var(--bm-mono); font-size: 12px; color: oklch(0.6 0.01 260); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-copy { font-family: var(--bm-mono); font-size: 10px; padding: 2px 6px; border: 1px solid oklch(0.9 0.005 260); border-radius: 4px; background: #fff; color: oklch(0.6 0.01 260); cursor: pointer; }
.bm-roster { display: flex; align-items: center; gap: 12px; font-size: 13px; color: oklch(0.5 0.01 260); }
.bm-avs { display: flex; }
.bm-av { width: 26px; height: 26px; border-radius: 50%; color: #fff; font-size: 11px; font-weight: 600; display: flex; align-items: center; justify-content: center; border: 2px solid #fff; }
.bm-av + .bm-av { margin-left: -8px; }
.bm-join { height: 40px; padding: 0 24px; border: none; border-radius: 9px; background: oklch(0.55 0.15 255); color: #fff; font: 600 14px var(--bm-ui); cursor: pointer; flex: none; }
.bm-join:hover { background: oklch(0.48 0.15 255); }
.bm-join.sec { background: #fff; border: 1px solid oklch(0.85 0.01 260); color: oklch(0.3 0.01 260); }
.bm-join:disabled { opacity: 0.5; cursor: default; }
.bm-foot { padding: 18px 40px 24px; font-family: var(--bm-mono); font-size: 11px; color: oklch(0.66 0.01 260); }
.bm-empty { padding: 48px 20px; text-align: center; color: oklch(0.55 0.01 260); }
.bm-empty h3 { margin: 12px 0 6px; font-size: 14px; color: oklch(0.24 0.01 260); }
.bm-err { color: oklch(0.53 0.19 25); padding: 0 40px 12px; font-size: 13px; }
.bm-create-form { padding: 0 40px 12px; display: flex; flex-direction: column; gap: 10px; }
.bm-create-extra { display: flex; flex-direction: column; gap: 8px; }
.bm-check { display: flex; align-items: center; gap: 8px; font-size: 13px; color: oklch(0.42 0.01 260); cursor: pointer; white-space: nowrap; }
.bm-check input { margin: 0; }
.bm-desc-input { width: 100%; min-height: 72px; border: 1px solid oklch(0.9 0.005 260); border-radius: 10px; background: oklch(0.98 0.002 260); padding: 10px 14px; font: 14px var(--bm-ui); color: inherit; resize: vertical; }
.bm-room-desc { font-size: 13px; color: oklch(0.45 0.01 260); white-space: pre-wrap; max-height: 4.5em; overflow: hidden; }
.bm-room-owner { font-size: 12px; color: oklch(0.48 0.01 260); }
.bm-room-icon { width: 28px; height: 28px; border-radius: 7px; object-fit: cover; flex: none; background: oklch(0.94 0.005 260); }
.bm-tag { font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.04em; padding: 3px 7px; border-radius: 5px; background: oklch(0.95 0.02 85); color: oklch(0.45 0.06 85); }
.bm-join-col { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; flex: none; }

.bm-call { flex: 1; min-height: 0; position: relative; display: flex; flex-direction: column; background: oklch(0.19 0.008 265); color: oklch(0.97 0.004 265); overflow: hidden; }
.bm-top { height: 62px; flex: none; padding: 0 22px; display: flex; align-items: center; justify-content: space-between; gap: 20px; border-bottom: 1px solid oklch(0.26 0.008 265); }
.bm-back { width: 30px; height: 30px; border-radius: 8px; border: 1px solid oklch(0.32 0.008 265); background: transparent; color: oklch(0.78 0.01 265); font-size: 15px; cursor: pointer; }
.bm-rname { font-size: 15px; font-weight: 600; }
.bm-rid { font-family: var(--bm-mono); font-size: 11px; color: oklch(0.62 0.01 265); }
.bm-chip2 { display: flex; align-items: center; gap: 7px; padding: 6px 10px; border-radius: 7px; background: oklch(0.26 0.008 265); font-size: 12px; }
.bm-body { flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 18px 18px 0; cursor: pointer; }
.bm-stage { flex: 1; min-height: 0; position: relative; border-radius: 12px; overflow: hidden; background: repeating-linear-gradient(135deg, oklch(0.28 0.01 265) 0 10px, oklch(0.25 0.01 265) 10px 20px); display: flex; align-items: center; justify-content: center; }
.bm-badge { position: absolute; left: 14px; bottom: 14px; display: flex; align-items: center; gap: 8px; padding: 6px 11px; border-radius: 8px; background: oklch(0.15 0.008 265 / 0.72); font-size: 13px; z-index: 2; }
.bm-hd { position: absolute; right: 14px; top: 14px; padding: 5px 9px; border-radius: 7px; background: oklch(0.15 0.008 265 / 0.72); font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.06em; color: oklch(0.88 0.01 265); z-index: 2; }
.bm-pip { position: absolute; right: 14px; bottom: 14px; width: 212px; height: 120px; border-radius: 10px; overflow: hidden; border: 1px solid oklch(0.4 0.01 265); background: oklch(0.23 0.01 265); z-index: 2; display: flex; align-items: center; justify-content: center; }
.bm-rail { flex: none; height: 104px; display: flex; align-items: center; gap: 10px; padding: 14px 0 6px; overflow-x: auto; }
.bm-slot { flex: none; position: relative; }
.bm-tile { flex: none; width: 152px; height: 84px; border-radius: 9px; background: oklch(0.23 0.01 265); border: 1px solid oklch(0.3 0.008 265); position: relative; overflow: hidden; padding: 0; cursor: pointer; color: inherit; }
.bm-tile.active { outline: 2px solid oklch(0.6 0.14 255); outline-offset: -2px; }
.bm-active { position: absolute; top: 6px; left: 6px; background: oklch(0.6 0.14 255); color: #fff; font-family: var(--bm-mono); font-size: 9px; padding: 2px 5px; border-radius: 4px; z-index: 2; }
.bm-mutechip {
  position: absolute; right: 7px; top: 7px; z-index: 2;
  width: 20px; height: 20px; border-radius: 6px;
  display: grid; place-items: center;
  background: oklch(0.52 0.18 25); color: #fff;
  pointer-events: none;
}
.bm-mutechip.stage { right: 56px; top: 14px; width: 22px; height: 22px; }
.bm-micmeter { width: 42px; height: 4px; border-radius: 2px; background: oklch(0.32 0.01 265); overflow: hidden; }
.bm-micmeter i { display: block; width: 100%; height: 100%; transform: scaleX(0); transform-origin: left center; background: oklch(0.72 0.16 150); border-radius: 2px; }
.tile-fallback { position: relative; }
.tile-fallback .bm-micmeter { margin-top: 2px; }
.bm-video + .bm-micmeter, .bm-badge + .bm-micmeter { position: absolute; left: 14px; bottom: 40px; z-index: 2; }
.bm-float { position: absolute; left: 0; right: 0; bottom: 126px; z-index: 3; display: flex; justify-content: center; pointer-events: none; }
.bm-pill { pointer-events: auto; display: flex; align-items: center; gap: 14px; border-radius: 44px; padding: 12px 20px; background: oklch(0.16 0.008 265 / 0.72); backdrop-filter: blur(14px); border: 1px solid oklch(0.4 0.01 265 / 0.5); }
.bm-ctrl { width: 56px; height: 56px; border-radius: 50%; border: 0; background: oklch(0.32 0.01 265 / 0.85); color: #fff; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; }
.bm-ctrl:hover { background: oklch(0.4 0.01 265 / 0.9); }
.bm-ctrl:disabled { opacity: 0.5; cursor: wait; }
.bm-ctrl span { font-family: var(--bm-mono); font-size: 9px; letter-spacing: 0.1em; }
.bm-ctrl.off { background: oklch(0.34 0.07 25 / 0.9); color: oklch(0.72 0.13 25); }
.bm-ctrl[aria-pressed="true"] { background: oklch(0.45 0.08 255 / 0.95); }
.bm-micwrap { position: relative; flex: none; }
.bm-micpick {
  position: absolute; right: -2px; bottom: -2px; z-index: 2;
  width: 20px; height: 20px; border-radius: 50%; padding: 0;
  border: 1px solid oklch(0.4 0.01 265 / 0.6);
  background: oklch(0.22 0.01 265 / 0.95); color: #fff; cursor: pointer;
  display: grid; place-items: center;
}
.bm-micpick:hover { background: oklch(0.32 0.01 265); }
.bm-micmenu {
  position: absolute; left: 0; bottom: calc(100% + 12px); z-index: 8;
  min-width: 240px; max-width: min(340px, 78vw); max-height: 360px; overflow: auto;
  padding: 8px; border-radius: 12px;
  background: oklch(0.16 0.008 265 / 0.94); backdrop-filter: blur(16px);
  border: 1px solid oklch(0.4 0.01 265 / 0.5);
  box-shadow: 0 12px 32px oklch(0.08 0.01 265 / 0.45);
}
.bm-micmenu-h {
  font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.08em;
  color: oklch(0.65 0.01 265); padding: 6px 10px 8px;
}
.bm-micmenu-spk {
  margin-top: 6px; padding-top: 10px;
  border-top: 1px solid oklch(0.4 0.01 265 / 0.35);
}
.bm-micopt {
  width: 100%; display: block; text-align: left;
  padding: 10px 12px; border: 0; border-radius: 8px;
  background: transparent; color: oklch(0.95 0.004 265);
  font: 13px var(--bm-ui); cursor: pointer;
}
.bm-micopt:hover { background: oklch(0.3 0.01 265 / 0.8); }
.bm-micopt.on { background: oklch(0.32 0.05 255 / 0.8); }
.bm-micopt:disabled { opacity: 0.55; cursor: default; }
.bm-micempty { padding: 8px 12px 10px; font-size: 12px; color: oklch(0.78 0.01 265); line-height: 1.4; }
.bm-fxwrap { position: relative; flex: none; }
.bm-fxmenu {
  position: absolute; left: 50%; bottom: calc(100% + 12px); transform: translateX(-50%); z-index: 8;
  width: min(320px, calc(100vw - 32px)); max-height: min(360px, 50vh); overflow: auto;
  padding: 8px 10px 12px; border-radius: 12px;
  background: oklch(0.16 0.008 265 / 0.94); backdrop-filter: blur(16px);
  border: 1px solid oklch(0.4 0.01 265 / 0.5);
  box-shadow: 0 12px 32px oklch(0.08 0.01 265 / 0.45);
  text-align: left;
}
.bm-fxtitle { margin: 8px 10px 4px; font-size: 13px; font-weight: 600; }
.bm-fxsteps { margin: 0 10px 8px; padding-left: 18px; font-size: 13px; line-height: 1.45; color: oklch(0.95 0.004 265); }
.bm-fxsteps li { margin: 4px 0; }
.bm-fxnote { margin: 0 10px 8px; font-size: 12px; line-height: 1.45; color: oklch(0.78 0.01 265); }
.bm-leave { height: 56px; padding: 0 30px; border: 0; border-radius: 28px; background: oklch(0.53 0.19 25); color: #fff; font: 600 15px var(--bm-ui); cursor: pointer; }
.bm-leave:hover { background: oklch(0.46 0.19 25); }
.bm-div { width: 1px; height: 44px; background: oklch(0.45 0.01 265 / 0.5); }
.bm-reveal { position: absolute; left: 50%; bottom: 132px; transform: translateX(-50%); z-index: 3; padding: 8px 16px; border-radius: 20px; border: 0; background: oklch(0.16 0.008 265 / 0.72); backdrop-filter: blur(14px); color: oklch(0.88 0.01 265); font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.08em; cursor: pointer; }
.bm-chat { position: absolute; left: 18px; bottom: 126px; z-index: 4; width: 320px; height: 340px; border-radius: 14px; background: oklch(0.16 0.008 265 / 0.86); backdrop-filter: blur(16px); border: 1px solid oklch(0.4 0.01 265 / 0.5); display: flex; flex-direction: column; overflow: hidden; }
.bm-chat-h { height: 44px; flex: none; display: flex; align-items: center; justify-content: space-between; padding: 0 12px; font-size: 13px; font-weight: 600; }
.bm-msgs { flex: 1; overflow: auto; padding: 8px 14px; display: flex; flex-direction: column; gap: 12px; }
.bm-msg { display: flex; align-items: flex-start; gap: 10px; }
.bm-msg-body { min-width: 0; flex: 1; }
.bm-toast-row { display: flex; align-items: flex-start; gap: 10px; text-align: left; }
.bm-who { font-family: var(--bm-mono); font-size: 10px; color: oklch(0.65 0.01 265); }
.bm-when { color: oklch(0.55 0.01 265); }
.bm-txt { font-size: 13px; line-height: 1.45; color: oklch(0.95 0.004 265); text-wrap: pretty; overflow-wrap: anywhere; }
.bm-txt .bm-link { color: oklch(0.78 0.12 255); text-decoration: underline; text-underline-offset: 2px; }
.bm-comp { display: flex; gap: 8px; padding: 10px; }
.bm-comp input { flex: 1; height: 36px; border-radius: 9px; border: 1px solid oklch(0.4 0.01 265 / 0.6); background: oklch(0.22 0.01 265 / 0.8); color: #fff; padding: 0 10px; font: 13px var(--bm-ui); }
.bm-send { height: 36px; padding: 0 12px; border: 0; border-radius: 9px; background: oklch(0.55 0.15 255); color: #fff; font: 600 13px var(--bm-ui); cursor: pointer; }
.bm-toast { position: absolute; left: 18px; bottom: 200px; z-index: 4; max-width: 280px; padding: 10px 12px; border-radius: 11px; background: oklch(0.16 0.008 265 / 0.86); backdrop-filter: blur(12px); cursor: pointer; }
.bm-friend {
  position: fixed; z-index: 6; width: 240px;
  border-radius: 12px; padding: 12px;
  background: oklch(0.16 0.008 265 / 0.92); backdrop-filter: blur(16px);
  border: 1px solid oklch(0.4 0.01 265 / 0.5);
  box-shadow: 0 12px 32px oklch(0.08 0.01 265 / 0.45);
  display: flex; flex-direction: column; gap: 10px;
}
.bm-friend-h { display: flex; align-items: center; gap: 10px; }
.bm-friend-name { font-size: 14px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-friend-sub { font-family: var(--bm-mono); font-size: 10px; color: oklch(0.65 0.01 265); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-friend-go {
  height: 40px; border: 0; border-radius: 9px;
  background: oklch(0.55 0.15 255); color: #fff;
  font: 600 13px var(--bm-ui); cursor: pointer;
}
.bm-friend-go:hover { background: oklch(0.48 0.15 255); }
.bm-friend-go:disabled { opacity: 0.55; cursor: default; }
.bm-friend-hint { font-size: 12px; color: oklch(0.78 0.12 25); line-height: 1.4; }
.bm-unread { position: absolute; top: -4px; right: -4px; min-width: 16px; height: 16px; padding: 0 4px; border-radius: 8px; background: oklch(0.6 0.14 255); color: #fff; font-family: var(--bm-mono); font-size: 10px; display: grid; place-items: center; }
.bm-status { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; background: oklch(0.19 0.008 265); color: oklch(0.97 0.004 265); cursor: pointer; }
.bm-status-hint { font-size: 14px; color: oklch(0.78 0.01 265); }
.bm-reconnect {
  position: absolute; left: 50%; top: 70px; transform: translateX(-50%); z-index: 6;
  padding: 8px 16px; border-radius: 20px; pointer-events: none;
  background: oklch(0.16 0.008 265 / 0.86); backdrop-filter: blur(12px);
  color: oklch(0.95 0.004 265); font: 600 13px var(--bm-ui);
  border: 1px solid oklch(0.4 0.01 265 / 0.5);
}
.bm-spin { width: 52px; height: 52px; border-radius: 50%; border: 2px solid oklch(0.32 0.01 265); border-top-color: oklch(0.6 0.14 255); animation: bm-spin 0.9s linear infinite; }
@keyframes bm-spin { to { transform: rotate(360deg); } }
.bm-video { width: 100%; height: 100%; object-fit: cover; background: #000; display: block; }
.bm-video.stage { object-fit: contain; }
.bm-retry { height: 40px; padding: 0 18px; border: 0; border-radius: 9px; background: oklch(0.6 0.14 255); color: #fff; font: 600 13px var(--bm-ui); cursor: pointer; }
.bm-signin { height: 44px; padding: 0 18px; border: none; border-radius: 10px; background: oklch(0.25 0.01 260); color: #fff; font: 600 13px var(--bm-ui); cursor: pointer; }
.bm-signin:disabled { opacity: 0.6; cursor: default; }
.bm-signmenu { position: relative; }
.bm-signopts {
  position: absolute; top: calc(100% + 6px); right: 0; z-index: 8;
  min-width: 228px; padding: 6px;
  border: 1px solid oklch(0.88 0.005 260); border-radius: 12px;
  background: #fff; box-shadow: 0 12px 32px oklch(0.24 0.01 260 / 0.14);
}
.bm-signopt {
  width: 100%; display: flex; flex-direction: column; align-items: flex-start; gap: 2px;
  padding: 10px 12px; border: 0; border-radius: 8px; background: transparent;
  cursor: pointer; text-align: left; font: 600 13px var(--bm-ui); color: oklch(0.24 0.01 260);
  text-decoration: none; box-sizing: border-box;
}
.bm-signopt:hover { background: oklch(0.97 0.004 260); }
.bm-signopt:disabled { opacity: 0.55; cursor: default; }
.bm-signopt:disabled:hover { background: transparent; }
.bm-signopt small { font: 11px var(--bm-mono); font-weight: 400; color: oklch(0.55 0.01 260); }
.bm-ident { display: flex; align-items: center; gap: 10px; }
.bm-ident-av { border: 0; background: transparent; padding: 0; cursor: pointer; display: flex; }
.bm-ident-name { border: 0; background: transparent; padding: 0; cursor: pointer; text-align: left; color: inherit; font: 600 13px var(--bm-ui); max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-ident-name:hover { text-decoration: underline; }
.bm-ident-actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 2px; }
.bm-signout { border: 0; background: transparent; padding: 0; font: 11px var(--bm-mono); color: oklch(0.55 0.01 260); cursor: pointer; }
.bm-host-link { border: 0; background: transparent; padding: 0; font: 11px var(--bm-mono); color: oklch(0.45 0.08 255); cursor: pointer; }
.bm-host {
  flex: 1; min-height: 0; display: flex; flex-direction: column;
  background: oklch(0.995 0.002 260); color: oklch(0.24 0.01 260);
}
.bm-host-head { padding: 32px 40px 16px; display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }
.bm-host-head h2 { margin: 0; font-size: 22px; font-weight: 600; }
.bm-host-head p { margin: 6px 0 0; font-size: 13px; color: oklch(0.55 0.01 260); max-width: 42em; }
.bm-host-tabs { padding: 0 40px 16px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.bm-host-select { height: 40px; border: 1px solid oklch(0.9 0.005 260); border-radius: 10px; background: #fff; padding: 0 10px; font: 13px var(--bm-ui); }
.bm-host-form { padding: 0 40px 16px; display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }
.bm-host-form .bm-search { min-width: 220px; }
.bm-host-table-wrap { flex: 1; min-height: 0; overflow: auto; padding: 0 40px 24px; }
.bm-host-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.bm-host-table th { text-align: left; font: 11px var(--bm-mono); color: oklch(0.55 0.01 260); padding: 8px 10px; border-bottom: 1px solid oklch(0.9 0.005 260); }
.bm-host-table td { padding: 8px 10px; border-bottom: 1px solid oklch(0.94 0.004 260); font-family: var(--bm-mono); font-size: 12px; vertical-align: top; }
.bm-x { width: 28px; height: 28px; border: 0; border-radius: 8px; background: transparent; color: inherit; cursor: pointer; font-size: 18px; }
.bm-x:hover { background: oklch(0.3 0.01 265 / 0.7); }
.bm-you { font-family: var(--bm-mono); font-size: 10px; color: oklch(0.7 0.01 265); }
.bm-pip-off { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; width: 100%; height: 100%; }
.bm-acct { padding: 0 40px 16px; display: grid; grid-template-columns: 1.15fr 0.85fr; gap: 16px; }
.bm-acct-card { border: 1px solid oklch(0.88 0.005 260); border-radius: 12px; background: #fff; padding: 18px 20px; }
.bm-acct-who { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
.bm-acct-name { font-size: 18px; font-weight: 600; }
.bm-acct-sub { font-size: 12px; color: oklch(0.55 0.01 260); margin-top: 2px; }
.bm-acct-dl { display: grid; gap: 8px; margin: 0; }
.bm-acct-dl > div { display: grid; grid-template-columns: 120px 1fr; gap: 8px; align-items: center; }
.bm-acct-dl dt { margin: 0; font-family: var(--bm-mono); font-size: 11px; color: oklch(0.55 0.01 260); }
.bm-acct-dl dd { margin: 0; font-family: var(--bm-mono); font-size: 12px; }
.bm-acct-bio { margin: 12px 0 0; font-size: 13px; color: oklch(0.42 0.01 260); }
.bm-acct-note { margin: 0 0 12px; font-size: 13px; color: oklch(0.45 0.01 260); }
.bm-acct-links { display: flex; flex-direction: column; align-items: flex-start; gap: 10px; }
.bm-acct-link { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; height: auto; padding: 10px 16px; border-radius: 10px; background: oklch(0.55 0.15 255); color: #fff; font: 600 14px var(--bm-ui); text-decoration: none; }
.bm-acct-link:hover { background: oklch(0.48 0.15 255); }
.bm-acct-link small { font: 11px var(--bm-mono); font-weight: 400; opacity: 0.9; }
.bm-acct-id { font-size: 11px; color: oklch(0.55 0.01 260); margin-top: 2px; }
.bm-acct-h { margin: 24px 0 8px; font-size: 15px; font-weight: 600; font-family: var(--bm-ui); }

@media (max-width: 768px) {
  .bm-list-head { padding: 20px 16px 16px; flex-direction: column; }
  .bm-list-head h1 { font-size: 24px; }
  .bm-mark { width: 28px; height: 28px; border-radius: 8px; }
  .bm-list-head p { margin-left: 40px; }
  .bm-filters { padding: 0 16px 16px; flex-wrap: wrap; }
  .bm-cards { padding: 0 16px; }
  .bm-card { padding: 16px; border-radius: 14px; flex-direction: column; align-items: stretch; }
  .bm-join { height: 36px; border-radius: 18px; }
  .bm-foot { padding: 16px; }
  .bm-call { background: oklch(0.17 0.008 265); }
  .bm-top { height: 56px; padding: 0 12px; }
  .bm-body { padding: 0 12px; }
  .bm-stage { border-radius: 16px; }
  .bm-pip { width: 96px; height: 132px; top: 14px; bottom: auto; right: 12px; border-radius: 12px; }
  .bm-badge { bottom: 106px; left: 12px; }
  .bm-rail { height: 92px; }
  .bm-tile { width: 110px; height: 72px; border-radius: 10px; }
  .bm-float { left: 10px; right: 10px; bottom: 128px; }
  .bm-pill { width: 100%; justify-content: space-around; gap: 6px; padding: 10px 12px; border-radius: 40px; }
  .bm-leave { width: 56px; padding: 0; border-radius: 50%; font-size: 0; }
  .bm-leave::after { content: ""; display: block; width: 14px; height: 14px; margin: 0 auto; background: #fff; border-radius: 2px; }
  .bm-chat { left: 0; right: 0; bottom: 0; width: auto; height: 400px; border-radius: 20px 20px 26px 26px; }
  .bm-friend { width: min(240px, calc(100vw - 24px)); }
  .bm-host-head, .bm-host-tabs, .bm-host-form, .bm-host-table-wrap { padding-left: 16px; padding-right: 16px; }
  .bm-acct { padding-left: 16px; padding-right: 16px; grid-template-columns: 1fr; }
  .bm-ctrl span { display: none; }
  .bm-fxmenu { position: fixed; left: 16px; right: 16px; bottom: 150px; transform: none; width: auto; }
}
@media (max-width: 420px) {
  .bm-pill { gap: 3px; padding: 10px 8px; }
  .bm-ctrl, .bm-leave { width: 44px; height: 44px; flex: none; }
  .bm-div { display: none; }
}

.bm-chipwrap { position: relative; }
.bm-acct-chip {
  height: 44px; padding: 0 12px 0 6px; border-radius: 22px;
  border: 1px solid oklch(0.9 0.005 260); background: #fff; color: inherit;
  display: flex; align-items: center; gap: 8px; cursor: pointer; font: inherit;
}
.bm-acct-chip-text { display: flex; flex-direction: column; align-items: flex-start; min-width: 0; }
.bm-acct-chip-name { font-size: 13px; font-weight: 600; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-acct-chip-role { font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.04em; color: oklch(0.55 0.01 260); }
.bm-acct-chip-caret { color: oklch(0.55 0.01 260); font-size: 11px; }
.bm-acct-menu {
  position: absolute; top: calc(100% + 8px); right: 0; z-index: 30;
  width: 280px; padding: 8px; border-radius: 12px; background: #fff;
  border: 1px solid oklch(0.9 0.005 260);
  box-shadow: 0 16px 40px -12px oklch(0.3 0.02 260 / 0.3);
}
.bm-acct-menu-h { display: flex; gap: 10px; align-items: center; padding: 8px 8px 10px; }
.bm-acct-item {
  width: 100%; height: 40px; border: 0; border-radius: 8px; background: transparent;
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  padding: 0 12px; font: 14px var(--bm-ui); color: inherit; cursor: pointer;
  text-decoration: none; box-sizing: border-box; text-align: left;
}
.bm-acct-item:hover { background: oklch(0.97 0.004 260); }
.bm-acct-item.danger { color: oklch(0.5 0.17 25); }
.bm-acct-menu-div { height: 1px; margin: 6px 8px; background: oklch(0.92 0.004 260); }
.bm-hostbadge {
  font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.06em;
  padding: 2px 6px; border-radius: 4px; background: oklch(0.94 0.025 255); color: oklch(0.38 0.13 255);
}
.bm-acct-page { flex: 1; min-height: 0; display: flex; flex-direction: column; background: oklch(0.995 0.002 260); color: oklch(0.24 0.01 260); }
.bm-acct-top {
  height: 64px; flex: none; display: grid; grid-template-columns: 1fr auto; align-items: center;
  gap: 16px; padding: 0 24px; border-bottom: 1px solid oklch(0.92 0.004 260);
}
.bm-acct-crumb { display: flex; align-items: center; gap: 10px; font-size: 15px; font-weight: 600; min-width: 0; }
.bm-acct-crumb .bm-mark { width: 28px; height: 28px; border-radius: 8px; }
.bm-acct-crumb-link { border: 0; background: transparent; padding: 0; font: inherit; color: oklch(0.45 0.01 260); cursor: pointer; }
.bm-acct-slash { color: oklch(0.7 0.01 260); font-weight: 400; }
.bm-acct-back, .bm-acct-mtitle { display: none; }
.bm-acct-body { flex: 1; min-height: 0; display: flex; }
.bm-acct-side {
  width: 248px; flex: none; background: oklch(0.985 0.002 260);
  border-right: 1px solid oklch(0.92 0.004 260); display: flex; flex-direction: column; padding: 20px 12px 16px;
}
.bm-acct-side .bm-acct-name { font-size: 14px; }
.bm-acct-nav { display: flex; flex-direction: column; gap: 4px; margin-top: 18px; }
.bm-acct-nav button {
  height: 40px; border: 0; border-radius: 8px; background: transparent;
  display: flex; align-items: center; justify-content: space-between; padding: 0 12px;
  font: 14px var(--bm-ui); color: oklch(0.3 0.01 260); cursor: pointer;
}
.bm-acct-nav button.on { background: oklch(0.94 0.025 255); color: oklch(0.38 0.13 255); font-weight: 600; }
.bm-acct-nav em { font-style: normal; font-family: var(--bm-mono); font-size: 11px; color: oklch(0.55 0.01 260); }
.bm-acct-nav button.on em { color: oklch(0.38 0.13 255); }
.bm-acct-side-foot { margin-top: auto; display: flex; flex-direction: column; gap: 10px; padding: 8px; }
.bm-acct-chat {
  display: flex; flex-direction: column; align-items: flex-start; gap: 2px;
  padding: 10px 12px; border-radius: 10px; border: 1px solid oklch(0.88 0.005 260);
  background: #fff; color: inherit; text-decoration: none; font: 600 13px var(--bm-ui);
}
.bm-acct-chat small { font: 11px var(--bm-mono); font-weight: 400; color: oklch(0.55 0.01 260); }
.bm-acct-keys { margin: 0; font-size: 12px; color: oklch(0.55 0.01 260); line-height: 1.4; }
.bm-acct-main { flex: 1; min-width: 0; overflow: auto; padding: 28px 32px 48px; }
.bm-acct-sec-h { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
.bm-acct-sec-h h2 { margin: 0; font-size: 22px; font-weight: 600; }
.bm-acct-sec-h p { margin: 6px 0 0; font-size: 13px; color: oklch(0.55 0.01 260); max-width: 40em; }
.bm-acct-mcard, .bm-acct-tabs, .bm-create-dash { display: none; }
.bm-acct-hero { margin-bottom: 16px; }
.bm-acct-hero .bm-acct-name { font-size: 18px; }
.bm-acct-rows { border: 1px solid oklch(0.9 0.005 260); border-radius: 12px; background: #fff; margin: 0; }
.bm-acct-rows > div { min-height: 48px; display: grid; grid-template-columns: 150px 1fr; gap: 8px; align-items: center; padding: 8px 16px; border-bottom: 1px solid oklch(0.94 0.004 260); }
.bm-acct-rows > div:last-child { border-bottom: 0; }
.bm-acct-rows dt { margin: 0; font-family: var(--bm-mono); font-size: 11px; color: oklch(0.55 0.01 260); }
.bm-acct-rows dd { margin: 0; font-family: var(--bm-mono); font-size: 12px; }
.bm-copyline { display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.bm-seg { display: inline-flex; border: 1px solid oklch(0.9 0.005 260); border-radius: 10px; overflow: hidden; background: #fff; margin-bottom: 14px; }
.bm-seg button { height: 36px; padding: 0 14px; border: 0; border-right: 1px solid oklch(0.92 0.004 260); background: transparent; font: 13px var(--bm-ui); color: oklch(0.42 0.01 260); cursor: pointer; }
.bm-seg button:last-child { border-right: 0; }
.bm-seg button.on { background: oklch(0.25 0.01 260); color: #fff; font-weight: 500; }
.bm-acct-rooms { display: flex; flex-direction: column; gap: 12px; margin-top: 4px; }
.bm-acct-room { border: 1px solid oklch(0.88 0.005 260); border-radius: 12px; background: #fff; padding: 16px 18px; }
.bm-acct-room-h { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }
.bm-acct-room-h > div:first-child { min-width: 0; flex: 1; }
.bm-acct-room-title { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.bm-acct-room-title .bm-name { font-size: 15px; }
.bm-acct-room-actions { display: flex; align-items: center; gap: 12px; flex: none; }
.bm-badge-host, .bm-badge-joined, .bm-badge-idle {
  font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.06em; padding: 3px 6px; border-radius: 5px;
}
.bm-badge-host { background: oklch(0.94 0.025 255); color: oklch(0.38 0.13 255); }
.bm-badge-joined { background: oklch(0.96 0.003 260); color: oklch(0.42 0.01 260); }
.bm-badge-idle { background: oklch(0.96 0.003 260); color: oklch(0.5 0.01 260); }
.bm-room-stats { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; margin-top: 12px; padding-top: 12px; border-top: 1px solid oklch(0.92 0.004 260); }
.bm-room-stats span { display: block; font-size: 11px; color: oklch(0.55 0.01 260); }
.bm-room-stats strong { display: block; margin-top: 4px; font-size: 13px; font-weight: 600; }
.bm-room-stats strong.muted { color: oklch(0.66 0.01 260); font-weight: 500; }
.bm-room-stats strong.warn { color: oklch(0.5 0.12 60); }
.bm-rec-status { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin: 0 0 12px; font-size: 13px; color: oklch(0.42 0.01 260); }
.bm-rec-status .on, .bm-rec-status .off { font-family: var(--bm-mono); font-size: 11px; letter-spacing: 0.04em; padding: 3px 8px; border-radius: 5px; }
.bm-rec-status .on { background: oklch(0.95 0.03 150); color: oklch(0.42 0.1 150); }
.bm-rec-status .off { background: oklch(0.96 0.003 260); color: oklch(0.45 0.01 260); }
.bm-rec-tools { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; margin-bottom: 12px; }
.bm-rec-search { flex: 1; min-width: 180px; max-width: 320px; }
.bm-rec-list { border: 1px solid oklch(0.88 0.005 260); border-radius: 12px; background: #fff; max-height: min(560px, 62vh); overflow: auto; }
.bm-rec-day {
  position: sticky; top: 0; z-index: 1; width: 100%; text-align: left; cursor: pointer;
  background: oklch(0.985 0.002 260); border: 0; border-bottom: 1px solid oklch(0.92 0.004 260);
  padding: 8px 14px; font: 12px var(--bm-mono); color: inherit;
}
.bm-rec-row { min-height: 52px; display: grid; grid-template-columns: 36px minmax(0, 1fr) auto auto; gap: 12px; align-items: center; padding: 8px 14px; border-bottom: 1px solid oklch(0.94 0.004 260); font-size: 13px; }
.bm-rec-glyph { width: 32px; height: 32px; border-radius: 8px; display: grid; place-items: center; background: oklch(0.96 0.003 260); font-family: var(--bm-mono); font-size: 11px; color: oklch(0.4 0.01 260); }
.bm-rec-meta, .bm-rec-empty { font-size: 12px; color: oklch(0.55 0.01 260); }
.bm-rec-pub { font-family: var(--bm-mono); font-size: 12px; color: oklch(0.45 0.01 260); max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bm-rec-play { height: 32px; padding: 0 12px; border-radius: 8px; border: 1px solid oklch(0.85 0.01 260); background: #fff; font: 600 12px var(--bm-ui); cursor: pointer; }
.bm-rec-player { padding: 0 14px 12px; }
.bm-rec-player audio, .bm-rec-player video { width: 100%; max-height: 360px; background: #111; }
.bm-rec-foot { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-top: 10px; font: 12px var(--bm-mono); color: oklch(0.55 0.01 260); }
.bm-hist-day { margin: 16px 0 6px; font: 12px var(--bm-mono); color: oklch(0.5 0.01 260); }
.bm-hist-row { display: grid; grid-template-columns: 88px auto minmax(0, 1fr) auto; gap: 12px; align-items: center; min-height: 44px; border-bottom: 1px solid oklch(0.94 0.004 260); font-size: 13px; }
.bm-hist-time, .bm-hist-src { font-family: var(--bm-mono); font-size: 12px; color: oklch(0.5 0.01 260); }
.bm-kind { font-family: var(--bm-mono); font-size: 10px; letter-spacing: 0.04em; padding: 3px 7px; border-radius: 5px; }
.bm-kind.join, .bm-kind.exit { background: oklch(0.96 0.003 260); color: oklch(0.45 0.01 260); }
.bm-kind.restart { background: oklch(0.95 0.025 255); color: oklch(0.42 0.12 255); }
.bm-kind.outage { background: oklch(0.96 0.025 25); color: oklch(0.48 0.15 25); }
.bm-kind.backUp { background: oklch(0.95 0.03 150); color: oklch(0.42 0.1 150); }
.bm-kind.recover { background: oklch(0.95 0.03 60); color: oklch(0.45 0.08 60); }
.bm-modal-back { position: fixed; inset: 0; z-index: 40; background: oklch(0.2 0.01 260 / 0.35); display: flex; align-items: center; justify-content: center; padding: 24px; }
.bm-modal { width: min(420px, 100%); background: #fff; border-radius: 14px; padding: 20px; display: flex; flex-direction: column; gap: 12px; box-shadow: 0 16px 40px -12px oklch(0.3 0.02 260 / 0.3); }
.bm-modal h3 { margin: 0; font-size: 18px; }
.bm-modal-actions { display: flex; justify-content: flex-end; gap: 8px; }
.bm-create-dash {
  height: 52px; border-radius: 12px; border: 1px dashed oklch(0.82 0.01 260); background: transparent;
  color: oklch(0.4 0.01 260); font: 600 14px var(--bm-ui); cursor: pointer;
}
@media (max-width: 768px) {
  .bm-acct-chip-text, .bm-acct-chip-caret { display: none; }
  .bm-acct-chip { width: 44px; height: 44px; padding: 0; justify-content: center; }
  .bm-acct-top { grid-template-columns: 40px 1fr auto; padding: 0 12px; }
  .bm-acct-crumb { display: none; }
  .bm-acct-back { display: grid; place-items: center; width: 36px; height: 36px; border-radius: 8px; border: 1px solid oklch(0.9 0.005 260); background: #fff; cursor: pointer; font-size: 16px; }
  .bm-acct-mtitle { display: block; margin: 0; text-align: center; font-size: 16px; font-weight: 600; }
  .bm-acct-side { display: none; }
  .bm-acct-main { padding: 16px; }
  .bm-acct-mcard { display: flex; align-items: center; gap: 12px; padding: 14px; margin-bottom: 12px; border: 1px solid oklch(0.88 0.005 260); border-radius: 14px; background: #fff; }
  .bm-acct-mcard-text { flex: 1; min-width: 0; }
  .bm-acct-tabs { display: grid; grid-template-columns: repeat(3, 1fr); margin-bottom: 14px; border: 1px solid oklch(0.9 0.005 260); border-radius: 10px; overflow: hidden; background: #fff; }
  .bm-acct-tabs button { height: 40px; border: 0; border-right: 1px solid oklch(0.92 0.004 260); background: transparent; font: 13px var(--bm-ui); color: oklch(0.42 0.01 260); cursor: pointer; }
  .bm-acct-tabs button:last-child { border-right: 0; }
  .bm-acct-tabs button.on { background: oklch(0.25 0.01 260); color: #fff; font-weight: 600; }
  .bm-create-desk { display: none; }
  .bm-create-dash { display: block; }
  .bm-acct-room-h { flex-direction: column; }
  .bm-room-stats { grid-template-columns: 1fr 1fr; }
  .bm-rec-row { min-height: 60px; grid-template-columns: 36px minmax(0, 1fr) auto; }
  .bm-rec-pub { display: none; }
  .bm-rec-play { width: 44px; height: 44px; padding: 0; border-radius: 50%; }
  .bm-hist-row { grid-template-columns: auto minmax(0, 1fr); }
  .bm-hist-time { grid-column: 1 / -1; }
  .bm-modal-back { align-items: flex-end; padding: 0; }
  .bm-modal { width: 100%; border-radius: 20px 20px 0 0; padding: 20px 16px 28px; }
}
`;

function ensureFavicon() {
  const href = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(faviconSvg)}`;
  let link = document.querySelector('link[rel="icon"][data-beagle-meet]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.setAttribute("data-beagle-meet", "1");
    document.head.appendChild(link);
  }
  link.href = href;
  if (!document.title || document.title === "Beagle Meet") {
    document.title = "Meetings — Beagle";
  }
}

let injected = false;
export function ensureMeetStyles() {
  if (typeof document === "undefined") return;
  let el = document.querySelector("style[data-beagle-meet]");
  if (!el) {
    el = document.createElement("style");
    el.setAttribute("data-beagle-meet", "1");
    document.head.appendChild(el);
  }
  el.textContent = CSS;
  injected = true;
  ensureFavicon();
}
